angular.module('rjmNg.directives').directive 'sharedDashboards', [
  () ->
    restrict: 'E'
    replace: false
    controllerAs: "view"
    bindToController: true
    templateUrl: "directive.browseSharedDash.html"
    controller: [
      "$scope",
      "dashboardService",
      "app",
      "$http",
      "$location",
      "$rootScope",
      "Users"
      "logger"
      "appRoute"
      "stringService"
      (
        $scope
        dashboardService
        app
        $http
        $location
        $rootScope
        Users
        logger
        appRoute
        stringService
      ) ->
        view = @
        view.users = {}
        view.userIds = null
        view.welcome = app.getDashboards().length < 1
        view.loading = true
        view.usersLoaded = 0
        view.searchDashboards = ""
        view.USER_ID = app.getUserId()

        _logEvent = (buttonType, key, value, action) ->
          switch buttonType
            when "Browse"
              logger.log('Popular Dashboard List Usage (Browse Button)', key, value, action)
            when "Find"
              logger.log('Popular Dashboard List Usage (Find Button)', key, value, action)
            else
              logger.log('Popular Dashboard List Usage (No Dashboards)', key, value, action)

        _logEvent($scope.buttonType, "Open", 1, "view")

        # Get the available dashboards and use the auth service
        # to connect them with usernames
        dashboardService.getAvailable(true).then( (dashboards) ->
          view.dashboards = []
          clientId = app.getClientId()
          view.userIds = _.uniq(dashboards.map (dashboard) -> dashboard.userId)
          for userId in view.userIds
            Users.get(userId).then( (user) ->
              # Make sure the user is active on this client
              rights = user.clientRights
              if rights[clientId]?.active
                view.users["#{user.id}"] = user
                view.dashboards = view.dashboards.concat (
                  dashboards.filter (d) ->
                    d.userId is user.id
                )
              view.usersLoaded += 1
            ).catch (error) ->
              # Could get here if a user is deactivated
              view.usersLoaded += 1
              
        )

        view.filterDashboards = (dashboard) ->
          regex = stringService.escapeRegEx(view.searchDashboards)
          return RegExp(regex, "i").test(view.users[dashboard.userId].name)

        view.toggleShare = (dashboard) ->
          # Can't unshare yourself
          if dashboard.userId is app.getUserId()
            return

          if not dashboard.selected
            dashboard.userName = view.users[dashboard.userId].name
            _updateFollowedDashboard(dashboard)
            dashboardService.follow(dashboard).then( (success) ->
              _logEvent($scope.buttonType, "Save", 1, "edit")
            ,
            (error) ->
              # Something went wrong, undo what we did
              _updateUnfollowedDashboard(dashboard)
            )
          else
            _updateUnfollowedDashboard(dashboard)
            dashboardService.unfollow(dashboard).then( (success) ->
              _logEvent($scope.buttonType, "Save", 1, "delete")
            ,
            (error) ->
              _updateFollowedDashboard(dashboard)
            )

        _updateFollowedDashboard = (dashboard) ->
          dashboard.selected = true
          dashboard.shareCount += 1

        _updateUnfollowedDashboard = (dashboard) ->
          dashboard.selected = false
          dashboard.shareCount += -1

        view.doneClicked = () ->
          dashboards = app.getDashboards()
          if $scope.force and dashboards.length > 0
            $location.url appRoute("/#{dashboards[0].id}")
          $rootScope.$broadcast 'doneBrowsingDashboards'

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch 'view.usersLoaded', (newUsersLoaded, oldUsersLoaded) ->
        if view.userIds? and
          newUsersLoaded isnt oldUsersLoaded and
          newUsersLoaded is view.userIds.length
            view.loading = false
]
